import { queryString } from 'widget/player-widget';


export default function getQueryParams(url) {
  if (!url) {
    return {};
  }
  const query = url.match(/(?:\?|$)([^#]*)/)[1];
  return queryString.parse(query);
}



// WEBPACK FOOTER //
// ./src/shared/utils/get-query-params.js